<template>
  <!-- main area -->
  <div class="centerArea_wrapper">
    <Conference v-if="hall.has_video_player" :key="$route.fullPath" :conference="hall" :is-room="false" />
    <Corner v-for="corner in $store.getters['corner/getByHallId'](hall.id)" :key="corner.id" :hall="hall" :corner="corner" />
  </div>
</template>

<script>
import Conference from "../modules/Conference"
import Corner from "../modules/Corner"

export default {
  name: "Hall",
  components: {Corner, Conference},
  props: {
    hallSlug: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      conference: {},
      corners: {},
      scrollY: 0
    }
  },
  computed: {
    hall() {
      return this.$store.getters["hall/getBySlug"](this.hallSlug)
    }
  }
}
</script>
